var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6333_2553)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7251 16.4393C10.2659 16.8302 8.7172 16.7141 7.33259 16.1101C5.94797 15.506 4.80944 14.4498 4.1034 13.1143C4.0003 12.9187 3.82372 12.7721 3.61251 12.7067C3.40129 12.6413 3.17275 12.6624 2.97715 12.7655C2.78156 12.8686 2.63493 13.0452 2.56952 13.2564C2.50412 13.4677 2.5253 13.6962 2.6284 13.8918C4.4034 17.2585 8.32507 19.076 12.1567 18.0501C16.6026 16.8585 19.2401 12.2885 18.0492 7.84346C16.8576 3.39763 12.2884 0.760129 7.8434 1.95096C6.0822 2.42282 4.52428 3.45911 3.40836 4.90105C2.29243 6.34299 1.68006 8.11104 1.66507 9.93429C1.65924 10.6868 2.49424 11.1026 3.09257 10.7001L5.32007 9.1993C6.16007 8.63263 5.59674 7.32346 4.6084 7.5443L3.72674 7.74096C4.11537 6.66238 4.77559 5.70225 5.64362 4.95331C6.51164 4.20437 7.55814 3.69194 8.68202 3.46552C9.8059 3.23909 10.9692 3.30633 12.0595 3.66073C13.1498 4.01512 14.1303 4.64471 14.9063 5.48866C15.6822 6.33261 16.2274 7.36242 16.4892 8.47859C16.751 9.59476 16.7205 10.7596 16.4007 11.8605C16.0809 12.9615 15.4826 13.9614 14.6635 14.7636C13.8445 15.5658 12.8324 16.1432 11.7251 16.4401V16.4393Z",
    fill: "#808080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6333_2553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.292a74c9004076691f2a5acf98c5928b.svg";
export { ForwardRef as ReactComponent };